export const IBANCountries = [
  { code: "AD", length: 24 },
  { code: "AL", length: 28 },
  { code: "AT", length: 20 },
  { code: "BA", length: 20 },
  { code: "BE", length: 16 },
  { code: "BG", length: 22 },
  { code: "CH", length: 21 },
  { code: "CY", length: 28 },
  { code: "CZ", length: 24 },
  { code: "DE", length: 22 },
  { code: "DK", length: 18 },
  { code: "EE", length: 20 },
  { code: "ES", length: 24 },
  { code: "FI", length: 18 },
  { code: "FO", length: 18 },
  { code: "FR", length: 27 },
  { code: "GB", length: 22 },
  { code: "GI", length: 23 },
  { code: "GL", length: 18 },
  { code: "GR", length: 27 },
  { code: "HR", length: 21 },
  { code: "HU", length: 28 },
  { code: "IE", length: 22 },
  { code: "IL", length: 23 },
  { code: "IS", length: 26 },
  { code: "IT", length: 27 },
  { code: "LB", length: 28 },
  { code: "LI", length: 21 },
  { code: "LT", length: 20 },
  { code: "LU", length: 20 },
  { code: "LV", length: 21 },
  { code: "MC", length: 27 },
  { code: "ME", length: 22 },
  { code: "MK", length: 19 },
  { code: "MT", length: 31 },
  { code: "MU", length: 30 },
  { code: "NL", length: 18 },
  { code: "NO", length: 15 },
  { code: "PL", length: 28 },
  { code: "PT", length: 25 },
  { code: "RO", length: 24 },
  { code: "RS", length: 22 },
  { code: "SA", length: 24 },
  { code: "SE", length: 24 },
  { code: "SI", length: 19 },
  { code: "SK", length: 24 },
  { code: "SM", length: 27 },
  { code: "TN", length: 24 },
  { code: "TR", length: 26 },
  { code: "IR", length: 26 },
];

export const bankCardCodes = [
  "603799", // بانک ملی ایران
  "589210", // بانک سپه
  "627648", // بانک توسعه صادرات
  "627961", // بانک صنعت و معدن
  "603770", // بانک کشاورزی
  "628023", // بانک مسکن
  "627760", // پست بانک ایران
  "502908", // بانک توسعه تعاون
  "627412", // بانک اقتصاد نوین
  "622106", // بانک پارسیان
  "502229", // بانک پاسارگاد
  "639599", // بانک قوامین
  "627488", // بانک کارآفرین
  "621986", // بانک سامان
  "639346", // بانک سینا
  "639607", // بانک سرمایه
  "504706", // بانک شهر
  "502806", // بانک شهر
  "502938", // بانک دی
  "603769", // بانک صادرات
  "610433", // بانک ملت
  "627353", // بانک تجارت
  "585983", // بانک تجارت
  "589463", // بانک رفاه
  "627381", // بانک انصار
  "639370", // بانک مهر اقتصاد
  "507677", // موسسه اعتباری نور
  "628157", // موسسه اعتباری توسعه
  "505801", // موسسه اعتباری کوثر
  "606256", // موسسه اعتباری ملل (عسکریه)
  "606373", // بانک قرض الحسنه مهرایرانیان
  "504172", // بانک رسالت
];
